export const appDateTimeZone = "Europe/Prague";
